import { render, staticRenderFns } from "./TerminalesLink.vue?vue&type=template&id=c8ab5456&functional=true&"
import script from "./TerminalesLink.vue?vue&type=script&lang=js&"
export * from "./TerminalesLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports